import { Box, Button, Dialog, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { colors } from "../../../theme/palette";
import { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { getCreateEventTypeRoute } from "../../../routers/routeUtils";

const RulesPopUp = ({
  open,
  handleClose,
  eventType,
}: {
  open: boolean;
  handleClose: () => void;
  eventType: "training" | "friendly-match";
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "16px",
          background: "#FFF",
          border: "1px solid #EAECF0",
          minWidth: "485px",
        },
      }}
    >
      <Typography
        variant="body14Bold"
        sx={{
          display: "block",
          padding: "21px 0 17px",
          textAlign: "center",
          borderBottom: "1px solid #EAECF0",
        }}
      >
        {t("pages.events.createEvent.generalRules")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "20px 26px ",
          borderBottom: "1px solid #EAECF0",
          rowGap: "15px",
        }}
      >
        <Typography
          variant="body14Regular"
          sx={{
            color: colors.Dark600,
          }}
        >
          <Typography
            variant="body16ExtraBold"
            sx={{
              color: colors.Green100,
            }}
          >
            {t("pages.events.createEvent.freeGames")}{" "}
          </Typography>
          {t("pages.events.createEvent.freeGamesDescription")}
        </Typography>
        <Typography
          variant="body14Regular"
          sx={{
            color: colors.Dark600,
          }}
        >
          <Typography
            variant="body16ExtraBold"
            sx={{
              color: colors.Green100,
            }}
          >
            {t("pages.events.createEvent.paidGames")}{" "}
          </Typography>
          {t("pages.events.createEvent.paidGamesDescription")}
        </Typography>
        <Typography
          variant="body14Regular"
          sx={{
            color: colors.Dark600,
          }}
        >
          <Typography
            variant="body16ExtraBold"
            sx={{
              color: colors.Green100,
            }}
          >
            {t("pages.events.createEvent.gameScheduling")}{" "}
          </Typography>
          {t("pages.events.createEvent.gameSchedulingDescription")}
        </Typography>
        <Typography
          variant="body14Regular"
          sx={{
            color: colors.Dark600,
          }}
        >
          <Typography
            variant="body16ExtraBold"
            sx={{
              color: colors.Green100,
            }}
          >
            {t("pages.events.createEvent.gameCancellation")}{" "}
          </Typography>
          {t("pages.events.createEvent.gameCancellationDescription")}
        </Typography>
        <Typography
          variant="body14Regular"
          sx={{
            color: colors.Dark600,
          }}
        >
          <Typography
            variant="body16ExtraBold"
            sx={{
              color: colors.Green100,
            }}
          >
            {t("pages.events.createEvent.lateArrival")}{" "}
          </Typography>
          {t("pages.events.createEvent.lateArrivalDescription")}
        </Typography>
        <Typography
          variant="body14Regular"
          sx={{
            color: colors.Dark600,
          }}
        >
          <Typography
            variant="body16ExtraBold"
            sx={{
              color: colors.Green100,
            }}
          >
            {t("pages.events.createEvent.paymentProcessing")}{" "}
          </Typography>
          {t("pages.events.createEvent.paymentProcessingDescription")}
        </Typography>
        <Typography
          variant="body14Regular"
          sx={{
            color: colors.Dark600,
          }}
        >
          <Typography
            variant="body16ExtraBold"
            sx={{
              color: colors.Green100,
            }}
          >
            {t("pages.events.createEvent.codeOfConduct")}{" "}
          </Typography>
          {t("pages.events.createEvent.codeOfConductDescription")}
        </Typography>
      </Box>
      <Button
        fullWidth
        variant="primary-md"
        onClick={() => {
          handleClose();
          navigate(getCreateEventTypeRoute(eventType));
        }}
        autoFocus
        sx={{
          margin: "14px auto",
          maxWidth: "440px",
        }}
      >
        {t("pages.events.createEvent.agree")}
      </Button>
    </Dialog>
  );
};

export default RulesPopUp;
